<template>
    <b-modal id="system-messages-window" ref="system-messages-window" no-close-on-esc no-close-on-backdrop hide-footer size="xl">
        <app-carousel
            v-if="pendingMessages.length > 0"
            :items="
                pendingMessages.map((sm) => ({
                    title: sm.title,
                    description: sm.description,
                    image: sm.image_url,
                    buttons: [{ label: 'Marcar como leido', action: () => markAsRead(sm.id) }],
                }))
            "
            size="sm"
        >
            <template #buttons>
                <b-btn variant="primary">Marcar como leido</b-btn>
            </template>
        </app-carousel>
    </b-modal>
</template>
<script>
import appCarousel from '@controls/Carousel'
export default {
    components: {
        appCarousel,
    },
    props: {
        systemMessages: {
            type: Array,
            required: true,
            default: [],
        },
    },
    data: () => ({
        systemMessagesData: [],
    }),

    computed: {
        pendingMessages() {
            return this.systemMessages.filter((element) => !element.is_readed)
        },
    },
    methods: {
        async markAllAsReaded() {
            this.systemMessages.forEach(async (element) => {
                await this.markAsRead(element.id)
            })
        },
        async markAsRead(noticeId) {
            const { data } = await this.$repo.post(`system-message-user`, { systemMessageId: noticeId, userId: this.currentUser.id })

            if (!data.status) return toastr.error(`Ocurrió un error (${data.msg})`)

            const index = this.systemMessages.findIndex((element) => element.id == data.result.system_message_id)

            if (-1 === index) return

            const readed = { ...this.systemMessages[index], is_readed: true }

            this.systemMessages.splice(index, 1, readed)

            if (this.pendingMessages.length == 0) {
                this.closeModal('system-messages-window')
                this.$router.push({ name: this.currentProfile.login_page })
            }
        },
        openWindow() {
            this.openModal('system-messages-window')
        },
    },

    mounted() {
        //
    },
    created() {
        // Escuchar el evento personalizado "open-modal" emitido por el componente padre
        this.$parent.$on('open-notices-modal', this.openWindow)
    },
    beforeDestroy() {
        // Asegúrate de desvincular el evento cuando el componente se destruye
        this.$parent.$off('open-modal', this.openWindow)
    },
}
</script>
<style scoped>
/* .imagen-contenedor {
    max-height: 768px;
    height: auto;
}

.imagen-contenedor img {
    max-width: 100%;
    height: auto;
} */
.slider-image {
    margin: 0;
    padding: 0;
    max-width: 600px !important;
    max-height: 450px !important;
}
</style>
